import React, {ReactElement} from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {IMediaCardElement} from "../../interfaces/components/cards/IMediaCardElement";
import {ILanguageTokens} from "../../localization/LanguageTokens";
import {connect} from "react-redux";
import {IKImage} from 'imagekitio-react';
import {RootState} from "../../redux/store";
import {useNavigate} from "react-router-dom";
import {Box, styled} from "@mui/material";


const StyledCard = styled(Card)(({theme}) => ({
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
        transform: 'scale(1.02)',
        transition: 'transform 0.1s ease-in-out',
    },
}));

interface IProps {
    mediaCardElement: IMediaCardElement,
    languageTokens: ILanguageTokens,
}

function MediaCard(props: IProps): ReactElement {
    const {mediaCardElement, languageTokens} = props;
    const navigate = useNavigate();

    return (
        <StyledCard
            id={'MediaCard'}
            sx={{minWidth: 300, width: 300, maxWidth: 300, cursor: 'pointer'}}
            elevation={2}  // todo className={classes.root}
            onClick={() => navigate(mediaCardElement.route)}
        >
            <CardMedia
                component={() => <Box sx={{ minHeight: 220,}}>

                    <IKImage
                        path={mediaCardElement.thumbnail}
                        loading="lazy"
                        lqip={{active: true}}
                        alt={mediaCardElement.thumbnail}
                        src={mediaCardElement.thumbnail}
                        transformation={[{
                            width: 300,
                            height: 220,
                            quality: 100,
                            format: 'auto',
                        }]}
                    />
                </Box>
                }
            />
            <CardContent id={'CardContent'} sx={{paddingTop: 1.5}}>
                <Typography pb={0.5} variant="h5"  >{mediaCardElement.name}</Typography>
                <Typography variant="body1" >{mediaCardElement.description}</Typography>
            </CardContent>
        </StyledCard>
    );
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(MediaCard);
